import React from "react";
import { Tabs } from "antd";
import styles from "./school-info-tabs.module.css";
import SchoolAcademicYear from "./components/school-academic-year/school-academic-year";
import SchoolTerms from "./components/school-terms/school-terms";
import SchoolLevelsGrades from "./components/school-levels-grades/school-levels-grades";
import SchoolClasses from "./components/school-classes/school-classes";
import SchoolDepartments from "./components/school-departments/school-departments";
import SchoolSubjects from "./components/school-subjects/school-subjects";
import SchoolGradeScales from "./components/school-grade-scales/school-grade-scales";
import SchoolCoursework from "./components/school-coursework/school-coursework";
import SchoolRooms from "./components/school-rooms/school-rooms";
import ScheduleActivity from "./components/schedule-activity/schedule-activity";

const SchoolInfoTabs = () => {
  const items = [
    {
      key: "1",
      label: "Academic Year",
      children: <SchoolAcademicYear />,
    },
    {
      key: "2",
      label: "Terms",
      children: <SchoolTerms />,
    },
    // {
    //   key: "3",
    //   label: "Levels/Grades",
    //   children: <SchoolLevelsGrades />,
    // },
    {
      key: "4",
      label: "Classes",
      children: <SchoolClasses />,
    },
    {
      key: "5",
      label: "Departments",
      children: <SchoolDepartments />,
    },
    {
      key: "6",
      label: "Subjects",
      children: <SchoolSubjects />,
    },
    {
      key: "7",
      label: "Grade Scales",
      children: <SchoolGradeScales />,
    },
    {
      key: "8",
      label: "Coursework Type",
      children: <SchoolCoursework />,
    },
    {
      key: "9",
      label: "Schedule and Activity",
      children: <ScheduleActivity />,
    },
    {
      key: "10",
      label: "Rooms",
      children: <SchoolRooms />,
    },
  ];

  return (
    <div className={styles.schoolInfoTabs}>
      <Tabs
        default="1"
        items={items}
        type="card"
        tabBarStyle={{ borderBottom: "none" }} 
        destroyInactiveTabPane
      /> 
    </div>
  );
};

export default SchoolInfoTabs;
